import _ from 'lodash';
import Store from './Store';
import Template from './Template';
import { buildModels } from '../libraries/graphql';
import gql from 'graphql-tag';
import { min } from 'rxjs/operators';

export default class DraftSession extends Store {

  store = {
    _id: null, 
    index: null,
    draft: null, 
    fields: {},
    outputs: [],
    template: null, 
    createdAt: null,
  }

  constructor(props) {
    super(props);
    this.set(props);


    this.set('createdAt', this.get('createdAt') || new Date());


    return this.setup(props);
  }

  static schema = {
    DraftSession: {
      normalizeAs: 'Session',
      primaryKey: '_id',
      fields: {
        index: Number,
        draftId: String,
        createdAt: Date,
        // parents: ["DraftParent"],
        // participants: ["User"],
        // sessions: ["DraftSession"],
        fields: {}
      },
    },
  }

  setField(obj) {
    console.log('Setting field for DraftSession', obj);
    _.assign(this.store.fields, obj);
  } 

  toObject() {
    return this.store;
  }

  async syncCreate() {
    return (({ models, mutate, client }) => {
      const { DraftSession } = models;
      return new Promise((resolve, reject) => mutate(
        DraftSession('sessionCreateOne', this.serialize())
      ).generate(gqlStr => {
        console.log(gqlStr);
        resolve(client.mutate({
          mutation: gql(gqlStr)
        }).then((data) => {
          console.log('Got result from sessionCreateOne', data);
          this.set(data.sessionCreateOne)
        }));
      }));
    })(DraftSession.gql);
  }

  serialize() {
    return {
      fields: this.store.fields, 
      index: this.store.index, 
      draftId: this.store.draftId
    }
  }

  static mock() {
    const draftTemplate = Template.mock();
    const draftSessionTemplate = _.head(draftTemplate.sessions);

    return new DraftSession({
      index: 2,
      fields: {
        story_title: "This is my story",
        story_blurb: "Story Blurb",
        session_3_notes: "this is my draft notes lol"
      }
    });
  }

  static mockState({type} = { type: "start" }) {
    const draftTemplate = Template.mock();
    const draftSessionTemplate = _.head(draftTemplate.sessions);

    if (type === 'end') {
      return {
        current: _.head(draftTemplate.sessions), 
        next: _.nth(draftTemplate.sessions, 1),
        completed: [],
        remaining: _.slice(draftTemplate.sessions, 1)
      }
    }

    return {
      current: {}, 
      next: _.head(draftTemplate.sessions),
      completed: [],
      remaining: _.slice(draftTemplate.sessions, 1)
    }
  }

  static isDraftSession(obj) {
    return obj instanceof DraftSession; 
  }

}

buildModels(DraftSession);


// WEBPACK FOOTER //
// ./src/models/DraftSession.js